import { lexofficeConstants } from "./lexoffice.constants";
import { lexofficeService } from "../lexoffice.service";

export const lexofficeActions = {
    getStripeLexOfficeConfigurations,
    updateStripeLexOfficeConfiguration,
    deleteStripeLexOfficeConfiguration,
    getLexOfficeConnectionStatus,
    getLexOfficeLog,
    registerOrganization,
    refreshLexOfficeToken,
    toggleEditStripeLexOfficeConfigurationModal,
    toggleDeleteStripeLexOfficeConfigurationModal,
};

function updateStripeLexOfficeConfiguration(configuration) {
    return (dispatch) => {
        dispatch(request());

        return lexofficeService.updateStripeLexOfficeConfiguration(configuration).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(configuration) {
        return {
            type: lexofficeConstants.UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST,
            configuration,
        };
    }

    function success(result) {
        return {
            type: lexofficeConstants.UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: lexofficeConstants.UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE,
            errorMessage,
        };
    }
}

function getStripeLexOfficeConfigurations() {
    return (dispatch) => {
        dispatch(request());

        return lexofficeService.getStripeLexOfficeConfigurations().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return {
            type: lexofficeConstants.GET_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST,
        };
    }

    function success(result) {
        return {
            type: lexofficeConstants.GET_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: lexofficeConstants.GET_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE,
            errorMessage,
        };
    }
}

function deleteStripeLexOfficeConfiguration(configurationId, doCleanup) {
    return (dispatch) => {
        dispatch(request());

        return lexofficeService.deleteStripeLexOfficeConfiguration(configurationId, doCleanup).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {
            type: lexofficeConstants.DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST,
        };
    }

    function success(result) {
        return {
            type: lexofficeConstants.DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: lexofficeConstants.DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE,
            errorMessage,
        };
    }
}

function getLexOfficeConnectionStatus() {
    return (dispatch) => {
        dispatch(request());

        return lexofficeService.getLexOfficeConnectionStatus().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {
            type: lexofficeConstants.GET_LEX_OFFICE_CONNECTION_STATUS_REQUEST,
        };
    }

    function success(result) {
        return {
            type: lexofficeConstants.GET_LEX_OFFICE_CONNECTION_STATUS_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: lexofficeConstants.GET_LEX_OFFICE_CONNECTION_STATUS_FAILURE,
            errorMessage,
        };
    }
}

function getLexOfficeLog(amount, page, start, end) {
    return (dispatch) => {
        dispatch(request());

        return lexofficeService.getLexOfficeLog(amount, page, start, end).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: lexofficeConstants.GET_LEX_OFFICE_LOG_REQUEST };
    }

    function success(result) {
        return {
            type: lexofficeConstants.GET_LEX_OFFICE_LOG_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: lexofficeConstants.GET_LEX_OFFICE_LOG_FAILURE,
            errorMessage,
        };
    }
}

function registerOrganization(requestDto) {
    return (dispatch) => {
        dispatch(request());

        return lexofficeService.registerOrganization(requestDto).then(
            (result) => {
                dispatch(success(result));
                window.location.href = result;
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return {
            type: lexofficeConstants.REGISTER_LEX_OFFICE_ORGANIZATION_REQUEST,
        };
    }

    function success(result) {
        return {
            type: lexofficeConstants.REGISTER_LEX_OFFICE_ORGANIZATION_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: lexofficeConstants.REGISTER_LEX_OFFICE_ORGANIZATION_FAILURE,
            errorMessage,
        };
    }
}

function refreshLexOfficeToken() {
    return (dispatch) => {
        dispatch(request());

        return lexofficeService.refreshLexOfficeToken().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: lexofficeConstants.REFRESH_LEX_OFFICE_TOKEN_REQUEST };
    }

    function success(result) {
        return {
            type: lexofficeConstants.REFRESH_LEX_OFFICE_TOKEN_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: lexofficeConstants.REFRESH_LEX_OFFICE_TOKEN_FAILURE,
            errorMessage,
        };
    }
}

function toggleEditStripeLexOfficeConfigurationModal() {
    return (dispatch) => {
        dispatch({
            type: lexofficeConstants.TOGGLE_EDIT_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL,
        });
    };
}

function toggleDeleteStripeLexOfficeConfigurationModal(item) {
    return (dispatch) => {
        dispatch({
            type: lexofficeConstants.TOGGLE_DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL,
            item: item,
        });
    };
}
